const translations = {
  "en": {
    "EMA (7, 14)": "EMA (7, 14)",
    "EMA14:": "EMA14:",
    "EMA7:": "EMA7:"
  },
  "zh-tw": {
    "EMA (7, 14)": "EMA (7, 14)",
    "EMA14:": "EMA14：",
    "EMA7:": "EMA7："
  }
};

export default translations;
